import React from 'react'

const Footer = () => {
  return (
    <React.Fragment>
      <div className="container">
        <footer className="my-4">
          <p>© 2019-2020 Company, icoder. · <a to="#">Privacy</a> . <a to="#">Terms</a></p>
        </footer>
      </div>
    </React.Fragment>
  )
}

export default Footer
